import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useTranslation } from "react-i18next";
import { BulkTableModel, BulkTableModelTableNames } from "../../models/tables.model";
import { useDevicesContext } from "../../context/devices.context";

function getStaticColumns(bulkTableData, translateFunction) {

  const columns = [
    {
      name: BulkTableModelTableNames.operatorId,
      grow: 2,
      //selector: (row) => row[bulkTableData.Time],
      cell: (row) => <div>{row[BulkTableModel.operatorId]}</div>,
      sortable: true,
    },
    {
      name: BulkTableModelTableNames.deviceId,
      grow: 1,
      //selector: (row) => row[bulkTableData.MachineName],
      cell: (row) => <div className="font-weight-bold" value={row[BulkTableModel.deviceId]}>{row[BulkTableModel.deviceId]}</div>,
      sortable: true,
    },
    {
      name: BulkTableModelTableNames.address,
      grow: 2,
      //selector: (row) => row[bulkTableData.DeviceID],
      cell: (row) => <div className="font-weight-bold">{row[BulkTableModel.address]}</div>,
      sortable: true,
    },
    {
      name: BulkTableModelTableNames.streetNumber,
      grow: 1,
      //selector: (row) => row[bulkTableData.DeviceID],
      cell: (row) => <div className="font-weight-bold">{row[BulkTableModel.streetNumber]}</div>,
      sortable: true,
    },
    {
      name: BulkTableModelTableNames.country,
      grow: 1,
      //selector: (row) => row[bulkTableData.City],
      cell: (row) => <div className="font-weight-bold">{row[BulkTableModel.country]}</div>,
      sortable: true,
    },
    {
      name: BulkTableModelTableNames.zipCode,
      grow: 1,
      //selector: (row) => row[bulkTableData.City],
      cell: (row) => <div className="font-weight-bold">{row[BulkTableModel.country]}</div>,
      sortable: true,
    },
    {
      name: BulkTableModelTableNames.city,
      grow: 2,
      //selector: (row) => row[bulkTableData.Address],
      cell: (row) => <div className="font-weight-bold">{row[BulkTableModel.city]}</div>,
      sortable: true,
    },
    {
      name: BulkTableModelTableNames.ipAddress,
      grow: 2,
      //selector: (row) => row[bulkTableData.Address],
      cell: (row) => <div className="font-weight-bold">{row[BulkTableModel.ipAddress]}</div>,
      sortable: true,
    },
    {
      name: BulkTableModelTableNames.latitude,
      grow: 2,
      //selector: (row) => row[bulkTableData.Information],
      cell: (row) => <div>{row[BulkTableModel.latitude]}</div>,
      sortable: true,
    },
    {
      name: BulkTableModelTableNames.longitude,
      grow: 2,
      //selector: (row) => row[bulkTableData.Information],
      cell: (row) => <div>{row[BulkTableModel.longitude]}</div>,
      sortable: true,
    }
  ];

  return columns;
}

export function BulkAddDevicesTable({ bulkTableData }) {
  const { t: translate } = useTranslation();
  const { setSelectedDevices, setSelectedDevicesLength, setAllDevices } = useDevicesContext();

  const [selectedRows, setSelectedRows] = useState([])
  const [allRows, setAllRows] = useState([])

  const columns = getStaticColumns(bulkTableData, translate);

  const tableData = {
    columns,
    data: bulkTableData,
  };

  const selectedRowLengthAndAllRowLength = (deviceRows, numOfRows) => {
    if (deviceRows.length !== 0) {
      setSelectedDevices(deviceRows)
      setSelectedDevicesLength(deviceRows.length);
    }
    if (numOfRows !== 0) setAllDevices(numOfRows);
  };

  const handleSelectedRow = (state) => {
    setSelectedRows(state.selectedRows)
  }

  useEffect(() => {
    setAllRows(bulkTableData.length)
    selectedRowLengthAndAllRowLength(selectedRows, allRows)
  }, [selectedRows, bulkTableData])

  return (
      <DataTableExtensions {...tableData}>
        <DataTable
          columns={tableData.columns}
          data={tableData.data}
          defaultSortAsc={false}
          center={true}
          pagination
          highlightOnHover
          selectableRows
          selectableRowsComponent={Checkbox}
          onSelectedRowsChange={handleSelectedRow}
        />
      </DataTableExtensions>
  );
}

const Checkbox = React.forwardRef(({ onClick, ...rest }, ref) => {
    return (
      <>
        <div className="form-check align-bottom">
          <input
            type="checkbox"
            className="form-check-input"
            style={{ height: '20px', width: '20px' }}
            ref={ref}
            onClick={onClick}
            {...rest}
          />
          <label className="form-check-label" id="booty-check" />
        </div>
      </>
    );
  });